var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#FFF", fillRule: "evenodd", d: "M4 11h13.585l-3.292-3.293c-.39-.39-.39-1.024 0-1.414.39-.39 1.024-.39 1.414 0l4.872 4.87c.257.172.396.459.418.755.004.055.004.11 0 .163-.022.297-.16.584-.418.756l-4.872 4.87c-.39.39-1.024.39-1.414 0-.39-.39-.39-1.024 0-1.414L17.585 13H4c-1.333 0-1.333-2 0-2z" })
  );
});